import React, { useEffect, useState } from "react";
import { ModalProps } from "@components/atoms/Modal/types";
import SlideSheet from "@components/atoms/SlideSheet";
import WebPopup from "@components/atoms/PopUpWeb";
import Toast, { ToastConfig } from "react-native-toast-message";
import { toastConfig } from "@components/molecules/VDBToast";
import { useAppSettings } from "@redux/slices/globalSlice";
import { useTheme } from "styled-components/native";
import { StyleSheet, View } from "react-native";

const Modal = ({
  type,
  headerTitle,
  children,
  isOpen,
  onClose,
  paddingLeft,
  paddingRight,
  paddingTop,
  paddingBottom,
  minModalHeight,
  backgroundColor,
  headerBackgroundColor,
  headerTextColor,
  enableToastMessage = false,
  skipKeyboardAware,
  fillContentHeight,
  fitContent = false,
  size,
  widthPercent,
  style,
  hideHeader,
  transparent,
  noPadding,
  webHeight = "auto",
  showScrollbar = true,
  allowFullScreen,
  isJBT = false,
  disableScrollWeb = false,
  skipKeyboardAwareWeb = false,
  height = "auto",
  clearChat = false,
  handleClearChat = () => {},
  hideClearAllButton = true,
  handleClearAll = () => {},
  leftIcon,
  leftIconPress,
  centerTitle,
}: ModalProps) => {
  const theme = useTheme();
  const modalType = type ? type : theme.isLargeScreen ? "popUp" : "sheet";
  const getAppSettings = useAppSettings();
  const [visibilityTime, setVisibilityTime] = useState();
  useEffect(() => {
    if (getAppSettings.toast_display_time) {
      setVisibilityTime(getAppSettings.toast_display_time);
    }
  }, [getAppSettings]);
  return (
    <>
      {modalType === "sheet" ? (
        <SlideSheet
          onClose={onClose as () => void}
          isOpen={isOpen}
          headerTitle={headerTitle}
          paddingLeft={paddingLeft}
          paddingRight={paddingRight}
          paddingTop={paddingTop}
          paddingBottom={paddingBottom}
          minModalHeight={minModalHeight}
          backgroundColor={backgroundColor}
          style={style}
          skipKeyboardAware={skipKeyboardAware}
          fillContentHeight={fillContentHeight}
          fitContent={fitContent}
          allowFullScreen={allowFullScreen}
          height={height}
          clearChat={clearChat}
          handleClearChat={handleClearChat}
          hideClearAllButton={hideClearAllButton}
          handleClearAll={handleClearAll}
          leftIcon={leftIcon}
          leftIconPress={leftIconPress}
        >
          {children}
          {enableToastMessage && (
            <View style={styles.toastLayer} pointerEvents="box-none">
              <Toast
                config={toastConfig as unknown as ToastConfig}
                visibilityTime={visibilityTime ? Number(visibilityTime) : 5000}
              />
            </View>
          )}
        </SlideSheet>
      ) : (
        <WebPopup
          onClose={onClose as () => void}
          isOpen={isOpen}
          title={headerTitle}
          size={size}
          widthPercent={widthPercent}
          backgroundColor={backgroundColor}
          headerBackgroundColor={headerBackgroundColor}
          headerTextColor={headerTextColor}
          hideHeader={hideHeader}
          transparent={transparent}
          noPadding={noPadding}
          height={webHeight as string}
          showScrollbar={showScrollbar}
          isJBT={isJBT}
          disableScrollWeb={disableScrollWeb}
          style={style}
          skipKeyboardAwareWeb={skipKeyboardAwareWeb}
          hideClearAllButton={hideClearAllButton}
          handleClearAll={handleClearAll}
          leftIcon={leftIcon}
          leftIconPress={leftIconPress}
          centerTitle={centerTitle}
        >
          {children}
          {enableToastMessage && (
            <View style={styles.toastLayer} pointerEvents="box-none">
              <Toast
                config={toastConfig as unknown as ToastConfig}
                visibilityTime={visibilityTime ? Number(visibilityTime) : 5000}
              />
            </View>
          )}
        </WebPopup>
      )}
    </>
  );
};

const styles = StyleSheet.create({
  toastLayer: {
    position: "absolute",
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 9999,
    elevation: 9999,
  },
});

export default Modal;
